export const authLogin = (user, logout = false) => {
  return {
    type: 'AUTH_LOGIN',
    payload: { user, logout },
  };
};